import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/areas/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/areas`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/areas/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/areas`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/areas/${url.id}`, data, config),
};

export default requests;
